import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wilson-legends',
  templateUrl: './legends.component.html',
  styleUrls: ['./legends.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LegendsComponent {}
